export function humanizePhone(phone) {
  return `${phone.substr(0, 3)}-${phone.substr(3, 3)}-${phone.substr(6)}`;
}

export function encryptPhone(phone) {
  return `*** *** ${phone.substr(phone.length - 4)}`;
}

export function sanitizePhone(phone) {
  return phone.replace(/[^0-9]/g, '');
}

/* US Number format */
export function isTenDigitsNumber(str) {
  return /^\d{10}$/.test(str);
}
